import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { appNavigationConstants, appNavigationConstants_Mobile } from "../../../utils/constants/header.constants";
import {
  MOBILE_ACCOUNTS_ROUTE,
  HOME_ROUTE,
  MOBILE_MENU_ROUTE,
  MY_PROFILE_ROUTE,
  EXCHANGE_SPORTS_ROUTE,
  CASINO_ROUTE,
  INT_CASINO_ROUTE,
  LOGIN_ROUTE,
  useAppSelector,
} from "@hypexone/uicore";
import {
  useAppDispatch,
  setCompetition,
  setEventType,
  SPORTS_MAP,
} from "@hypexone/uicore";
import { isDesktop, isMobile } from "react-device-detect";
import React, { useState } from "react";
import HeaderSearchInput from "./HeaderSearchInput";
import { IoIosSettings } from "react-icons/io";


interface SubHeaderProps {
  disableSportsSubheader?: boolean;
}
const SubHeader: React.FC<SubHeaderProps> = ({ disableSportsSubheader }) => {
  const pathName = useLocation().pathname;
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { langData } = useAppSelector((state) => state.cms);
  const { loggedIn } = useAppSelector((state) => state.auth);

  const [isMobileSearchPopupOpen, setIsMobileSearchPopupOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [showSettings, setShowSettings] = useState(false);

  const bgGradient = "bg-gradient-to-b from-blue6 to-blue7";
  const activeTabBgGradient = "md:bg-gradient-to-b from-blue8 to-60% to-blue9";

  const handleNavLinkClick = (title: string) => {
    dispatch(setCompetition({ id: "", name: "", slug: "" }));
    const sport = SPORTS_MAP.get(title);
    if (sport) {
      dispatch(setEventType(sport));
    }
  };

  const onNavClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    title: string,
    navigationUrl: string,
  ) => {
    if (navigationUrl?.startsWith("/dc/")) {
      if (!loggedIn) {
        e.preventDefault();
        navigate(LOGIN_ROUTE, { replace: true });
      }
      return;
    }
    handleNavLinkClick(title);
  };
  const handleSettingClick = (e) => {
    e.preventDefault();
    const updatedState = { ...location.state, message: !showSettings };
    setShowSettings(!showSettings);
    navigate(location.pathname, { replace: true, state: updatedState });

  }
  const showSettingsTab =
    isDesktop &&
    /^\/exchange_sports\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(location.pathname);


  const excludedRoutes = [
    HOME_ROUTE,
    MOBILE_ACCOUNTS_ROUTE,
    MOBILE_MENU_ROUTE,
    MY_PROFILE_ROUTE,
    "/change-password",
    "/bonus_rewards",
  ];

  const excludeSubHeader =
    !excludedRoutes.includes(pathName) ||
    !pathName.startsWith(EXCHANGE_SPORTS_ROUTE);

  return (
    <div className="flex min-w-full font-bold text-[12px] md:bg-white text-white md:text-black">
      {isMobile && excludeSubHeader && (pathName == `${HOME_ROUTE}` ? true : disableSportsSubheader) && (
        <div className="flex bg-white justify-center w-full gap-[1px]">
          <div className="flex items-center w-full bg-black overflow-x-auto hide-scrollbar">
            <div className="flex mx-auto">
              {appNavigationConstants_Mobile.map(({ title, navigationUrl }, index) => (
                <NavLink
                  to={navigationUrl}
                  key={title}
                  className={({ isActive }) =>
                    `flex justify-center font-[400] items-center px-[10px] py-[7px] text-white text-[14px] text-nowrap 
          ${index !== appNavigationConstants_Mobile.length - 1 ? "border-r-[1px] border-gray4" : ""}
          ${isActive ? "bg-black1 border-x border-t border-white rounded-t-[8px]" : ""}
          ${title === "PrediX" ? "relative animate-textHighlight" : ""}`
                  }
                  onClick={(e) => onNavClick(e, title, navigationUrl)}
                >
                  {title}
                  {title === "PrediX" && (
                    <div className="absolute top-0 right-0 bg-red-500 text-white text-[8px] leading-none px-[2px] flex items-center justify-center blink rounded">
                      NEW
                    </div>
                  )}
                </NavLink>
              ))}
            </div>
          </div>

        </div>
      )}
      {isMobileSearchPopupOpen && (
        <div className="absolute bg-white p-2 top-0 w-full">
          <HeaderSearchInput
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            setIsMobileSearchPopupOpen={setIsMobileSearchPopupOpen}
          />
        </div>
      )}

      {isDesktop && <div className={`relative w-full ${activeTabBgGradient}`}>
        {<div className={`flex overflow-x-auto hide-scrollbar ${showSettingsTab ? "pr-[80px]" : ""}`}>
          {appNavigationConstants.map(({ title, navigationUrl, langKey }) => (
            <NavLink
              to={navigationUrl}
              key={title}
              className={({ isActive }) =>
                `hover:underline text-center text-xs py-[4px] text-nowrap px-3 mb-[2px] mt-[0.5px]
          border-r border-gray4 md:${bgGradient}
          ${title === "Casino" || title === "Int Casino"
                  ? "animate-highlight"
                  : title === "Sportsbook"
                    ? "bg-color text-white"
                    : ""}
          ${title === "Multi Market" ? "bg-color" : ""}
          ${title === "PrediX" ? "animate-textHighlight" : ""}
          ${isActive
                  ? `underline underline-offset-4 md:no-underline md:${activeTabBgGradient}`
                  : ""}`
              }
              onClick={(e) => onNavClick(e, title, navigationUrl)}
            >
              <div className="relative">
                {langData?.[langKey] ?? title}
                {(title === "Binary" || title === "Sportsbook" || title === "PrediX") && (
                  <div className="absolute blink top-[-6px] right-[-16px] bg-red-500 text-white text-[8px] px-[2px] flex items-center justify-center">
                    NEW
                  </div>
                )}
              </div>
            </NavLink>
          ))}
        </div>}

        {showSettingsTab && (
          <div
            onClick={(e) => handleSettingClick(e)}
            className="absolute top-0 gap-1 cursor-pointer right-0 h-full flex items-center bg-color text-white  px-2 py-[4px] mb-[2px] mt-[0.5px] border-l border-gray4 hover:text-blue-500"
          >
            <span className="transition-colors  text-[14px] font-[600]">Setting</span>
            <IoIosSettings className="w-4 h-4 mr-1 transition-colors" />
          </div>
        )}
      </div>}


    </div>
  );
};

export default SubHeader;
